var map = {
	"./NIM_Web_SDK_v5.8.0": "6539",
	"./NIM_Web_SDK_v5.8.0.js": "6539",
	"./NIM_Web_SDK_v6.1.0": "0e0c",
	"./NIM_Web_SDK_v6.1.0.js": "0e0c",
	"./NIM_Web_SDK_v8.0.0": "ced7",
	"./NIM_Web_SDK_v8.0.0.js": "ced7",
	"./NIM_Web_SDK_v8.0.0.min": "ffb8",
	"./NIM_Web_SDK_v8.0.0.min.js": "ffb8",
	"./NIM_Web_SDK_v8.1.0": "18b8",
	"./NIM_Web_SDK_v8.1.0.js": "18b8",
	"./NIM_Web_SDK_v8.1.0.min": "c889",
	"./NIM_Web_SDK_v8.1.0.min.js": "c889"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2b90";